import Poi from "@/model/Poi";
import {
  TravelMarker
} from "@/model/TravelMarker";
import Direction from "@/mixins/map/Direction";
import Config from "@/mixins/map/Config";
import Home from "@/mixins/map/Home";

export default {
  data() {
    return {
      activeVenue: null,
      apartmentGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      baseLayers: [],
      container: 'amenity-map',
      detailLayers: [],
      filteredGroupMarkers: [],
      filteredlotGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      groupMarkers: [],
      groups: [],
      groupVenueMarkers: [],
      lotSummaryList: [],
      lotgeo: require('@/assets/json/lotgeo.json'),
      map: null,
      mapLoad: false,
      masterBound: false,
      objects: [],
      objectGeojson: {
        type: 'FeatureCollection',
        features: [],
      },
      poi: null,
      padding: {
        top: 100,
        left: 100,
        right: 100,
        bottom: 100
      },
      route: null,
      svgConfig: null,
      stageGeoJson: {
        type: 'FeatureCollection',
        features: [],
      },
      travelMark: TravelMarker,
      travelMethod: 'driving',
      venues: null,
      venueMarkers: [],
    }
  },
  mixins: [Config, Direction, Home],
  computed: {},
  created() {},
  methods: {
    initMap: function (svgConfig, lotsummarylist) {
      let poe = null;
      if (window.location.pathname.includes('amenities')) {
        this.venues = [];
        const precinct = svgConfig.precincts.find(item => item.name.toLowerCase() === 'amenities');
        if (precinct) {
          svgConfig.venue.forEach(venue => {
            if (precinct.venues.includes(venue.id)) {
              this.venues.push(venue)
            }
          })
        }
      } else {
        this.venues = JSON.parse(JSON.stringify(svgConfig.venue));
      }
      this.venues = this.venues.sort((a, b) => (a.name > b.name) ? 1 : -1);
      this.groups = JSON.parse(JSON.stringify(svgConfig.poiGroups));
      this.lotSummaryList = lotsummarylist;
      mapboxgl.accessToken = 'pk.eyJ1Ijoic2FpbGVzaGtjIiwiYSI6ImNrZGo1Y2l5dTBibGIzMXBmbzM5Z2Q3Z2MifQ.hq_fP_fYTmUm_LJNRl23Cw';
      this.svgConfig = svgConfig;
      this.initConfig();
      this.map.flyTo({
        pitch: 60
      });
    },


    addOutine: function () {
      if (this.map.getSource('raster-tiles')) {
        this.map.removeLayer('terrain-data');
        this.map.removeSource('raster-tiles');
      }
      if (this.baseLayer) {
        this.map.addSource('raster-tiles', {
          type: 'raster',
          tiles: [
            this.baseLayer + '/{z}/{x}/{y}.png',
          ],
          tileSize: 256,
          minZoom: 16,
          maxZoom: 22,
        });

        this.map.addLayer({
          id: 'terrain-data',
          type: 'raster',
          source: 'raster-tiles',
          minZoom: 16,
          maxZoom: 22,
          paint: {
            'raster-opacity': 1,
          },
        });

        this.map.fitBounds(this.masterBound, {
          padding: 20
        });
      }
      this.mapLoad = true;
      this.mapObjects()
    },

    addLotShapes: function () {
      this.mapLoad = true;
      this.lotgeo.geoJson.features.forEach((feature) => {
        const lotname = feature.properties.lotName;
        const lotcpid = feature.properties.lotCpId;
        const lot = this.lotSummaryList.find(
          (item) => item.productname === lotname && item.lotcpid === lotcpid
        );
        if (lot) {
          feature.properties.lotproperties = lot;
          feature.id = lot.lotcpid;
          feature.properties.color = this.asignLotColor(lot.lotgroup);
          feature.properties.status = lot.currentstatusname;
          this.filteredlotGeoJson.features.push(feature);
        }
      });

      this.map.addSource('lots', {
        type: 'geojson',
        data: this.filteredlotGeoJson,
      });


      this.map.addLayer({
        id: 'lot-fills',
        type: 'fill',
        source: 'lots',
        layout: {},
        paint: {
          'fill-color': [
            'case',
            ['boolean', ['get', 'isActive'], false],
            '#fff',
            ['get', 'color'],
            // '#333'
          ],
          'fill-outline-color': '#333333',
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            0.4,
            0.9,
          ],
        },
      });
    },

    asignLotColor: function (size) {
      size = size.replace('ft', "'");
      if (size === "60'") {
        return '#ffab97';
      }
      if (size === "45'") {
        return '#EEBE64';
      }
      if (size === "50'") {
        return '#add5ee'
      }
      if (size === "70'") {
        return '#e6ceba'
      }
    },

    clearRoutes: function () {
      this.removeTravelMarker();
      const activeMarker = document.getElementById('marker-is-active');
      if (activeMarker) {
        activeMarker.id = '';
      }
      if (this.map.getSource('LineString')) {
        this.map.removeLayer('LineString');
        this.map.removeSource('LineString');
      }
    },

    clearMarkers: function () {
      const activeEl = document.getElementById('marker-is-active');
      if (activeEl) {
        activeEl.id = '';
      }
      this.markerBounds = null;

      this.filteredGroupMarkers.forEach(marker => {
        marker.remove();
      });

      this.groupVenueMarkers.forEach(marker => {
        marker.remove();
      });

      this.venueMarkers.forEach(marker => {
        marker.remove();
      });

      this.groupVenueMarkers = [];
      this.filteredGroupMarkers = [];
      this.venueMarkers = [];

      this.map.off('zoom')
    },

    addMarkers: function (markers) {
      const page = this.$route.name
      const ids = [];
      const groupMarkers = [];
      this.resize();
      this.clearMarkers();
      const bounds = new mapboxgl.LngLatBounds();
      bounds.extend(this.masterBound);
      if (markers.length) {
        markers.forEach(m => {
          this.poi[m].venue.forEach(venue => ids.push(venue.id));
          this.poi[m].groupedMarkers.forEach(marker => {
            bounds.extend(marker.getLngLat());
            this.groupVenueMarkers.push(marker);
          })
          this.poi[m].markers.forEach(marker => {
            this.venueMarkers.push(marker);
            marker.addTo(this.map);
            bounds.extend(marker.getLngLat());
          });
        });

        this.groupMarkers.forEach(marker => {
          const groupVenues = marker.venues.filter(id => ids.includes(id));
          if (groupVenues.length > 0) {
            this.filteredGroupMarkers.push(marker.marker);
            bounds.extend(marker.marker.getLngLat());
          }
        });

        this.toggleGroupMarkers();
      }

      this.markerBounds = bounds;
      this.currentBounds = bounds;

      this.map.fitBounds(this.masterBound)
      // if (page === 'places') {
      //   this.map.fitBounds(bounds, {
      //     padding: this.padding
      //   });
      // } else {
      // }
    },

    zoomToCategory: function (m) {
      const bounds = new mapboxgl.LngLatBounds();
      this.poi[m].groupedMarkers.forEach(marker => {
        bounds.extend(marker.getLngLat());
      })
      this.poi[m].markers.forEach(marker => {
        this.venueMarkers.push(marker);
        bounds.extend(marker.getLngLat());
      });
      this.map.fitBounds(bounds, {
        padding: this.padding,
        maxZoom: 16
      });
    },

    toggleGroupMarkers() {
      let showPoi = false;
      let showGroup = false;

      this.map.on('zoom', () => {
        if (this.map.getZoom() > 12) {
          if (!showPoi) {
            showPoi = true;
            showGroup = false;
            this.filteredGroupMarkers.forEach(marker => {
              marker.remove();
            })
            this.groupVenueMarkers.forEach(marker => {
              marker.addTo(this.map);
            })
          }
        } else {
          if (!showGroup) {
            showPoi = false;
            showGroup = true;
            this.filteredGroupMarkers.forEach(marker => {
              marker.addTo(this.map);
            })
            this.groupVenueMarkers.forEach(marker => {
              marker.remove();
            })
          }
        }

        if (this.map.getZoom() > 14) {
          this.venueMarkers.forEach(marker => {
            marker.getElement().classList.add('marker-is-active');
          })
          this.groupVenueMarkers.forEach(marker => {
            marker.getElement().classList.add('marker-is-active');
          })
        } else {
          this.venueMarkers.forEach(marker => {
            marker.getElement().classList.remove('marker-is-active');
          })
          this.groupVenueMarkers.forEach(marker => {
            marker.getElement().classList.remove('marker-is-active');
          })
        }
      });
    },

    categorisePoi: function () {
      let groupVenues = [];
      let venues = this.venues;
      let poi = Poi;
      let count = 0;

      this.groups.forEach(group => {
        const bounds = new mapboxgl.LngLatBounds();
        group.geojson[0].forEach((coord) => {
          bounds.extend([coord.lng, coord.lat]);
        });
        const center = bounds.getCenter();
        group.center = center;
        // const marker = new mapboxgl.Marker().setLngLat([center.lng, center.lat]);
        const marker = this.createGroupMarker(group)
        const groupVenue = {
          marker: marker,
          venues: []
        }

        group.venues.forEach(venueId => {
          groupVenues.push(venueId);
          groupVenue.venues.push(venueId);
        })
        this.groupMarkers.push(groupVenue);
      })


      venues.forEach(venue => {
        if (venue) {
          if (groupVenues.includes(venue.id)) {
            venue.hasParent = true;
          }
          this.categoryCheck(venue, poi)

          count += 1;
          if (venues.length === count) {
            this.poi = poi;
            this.$store.commit("setPoi", poi);
          }
        }
      });
    },

    categoryCheck: function (venue, poi) {
      let icon;
      let type;

      if (venue.subtype === 'Travel & Transport') {
        poi.transport.venue.push(venue);
        icon = poi.transport.iconUrl;
        type = 'transport';
      }

      if (venue.subtype === 'School') {
        poi.education.venue.push(venue);
        icon = poi.education.iconUrl;
        type = 'education';
      }

      if (venue.subtype === 'University & College') {
        poi.education.venue.push(venue);
        icon = poi.education.iconUrl;
        type = 'education';
      }

      if (venue.subtype === 'Outdoors & Recreation') {
        poi.outdoor.venue.push(venue);
        icon = poi.outdoor.iconUrl;
        type = 'outdoor';
      }

      if (venue.subtype === 'Food') {
        poi.food.venue.push(venue);
        icon = poi.food.iconUrl;
        type = 'food';
      }

      if (venue.poisubcategory === 'Child Care Service') {
        poi.childcare.venue.push(venue);
        icon = poi.childcare.iconUrl;
        type = 'childcare';
      }

      if (venue.subtype === 'Medical Center') {
        poi.health.venue.push(venue);
        icon = poi.health.iconUrl;
        type = 'health';
      }

      if (venue.subtype === 'Shop & Service') {
        poi.shopping.venue.push(venue);
        icon = poi.shopping.iconUrl;
        type = 'shopping';
      }

      if (venue && icon && type) {
        let pin = this.createMarker(venue, icon, type);
        if (venue.hasParent) {
          poi[type].groupedMarkers.push(pin)
        } else {
          poi[type].markers.push(pin);
        }
      }
    },

    createGroupMarker: function (venue) {
      const el = document.createElement('div');
      const pEl = document.createElement('p');
      const imgEl = document.createElement('img');
      const iEl = document.createElement('i');
      iEl.classList.add('fas', 'fa-map-marker-alt', 'fa-2x')
      pEl.innerText = venue.name;
      imgEl.src = require('@/assets/icons/cluster.svg');
      imgEl.style.height = '32px';
      imgEl.style.width = '32px';
      el.className = 'marker';
      el.classList.add('marker-is-active');
      el.style.height = '32px';
      el.appendChild(iEl);
      // el.appendChild(imgEl);
      el.appendChild(pEl);

      el.addEventListener('click', (e) => {
        const activeEl = document.getElementById('marker-is-active');
        if (activeEl) {
          activeEl.id = '';
        }
        this.map.flyTo({
          center: [venue.center.lng, venue.center.lat],
          zoom: 15,
          essential: true
        });
      });

      return new mapboxgl.Marker(el).setLngLat([venue.center.lng, venue.center.lat]);
    },

    createMarker: function (venue, icon, type) {
      // let showRoute = true;
      const el = document.createElement('div');
      const pEl = document.createElement('p');
      const imgEl = document.createElement('img');
      pEl.innerText = venue.name;
      imgEl.src = icon + '.svg';
      imgEl.style.height = '32px';
      imgEl.style.width = '32px';
      el.className = 'marker';
      el.classList.add(venue.id);
      // el.style.width = 'auto';
      el.style.height = '32px';
      el.appendChild(imgEl);
      el.appendChild(pEl);
      // if (venue.hasOwnProperty('showRoute')) {
      //   showRoute = venue.showRoute;
      // }
      el.addEventListener('click', (e) => {
        this.activeVenue = venue;
        this.$store.commit("setActiveVenue", venue);
        this.$store.dispatch('productTracking', {
          product: {
            productName: venue.name,
            category: venue.poisubcategory
          },
          page: 'poi-click'
        })
        const activeEl = document.getElementById('marker-is-active');
        if (activeEl) {
          activeEl.id = '';
        }
        el.id = 'marker-is-active';
      });
      el.addEventListener('mouseenter', (e) => {
        el.classList.add('is-hovered');
      });
      el.addEventListener('mouseout', (e) => {
        el.classList.remove('is-hovered');
      });

      const pin = new mapboxgl.Marker(el).setLngLat([venue.longitude, venue.latitude]);
      return pin;
    },

    highlightPoi(venue) {
      const activeEl = document.getElementById('marker-is-active');
      if (activeEl) {
        activeEl.id = '';
      }
      const clickedEl = document.getElementsByClassName(venue.id);
      if (clickedEl) {
        clickedEl[0].id = 'marker-is-active';
      }
    },

    flyToPoint: function (coord) {
      this.clearRoutes();
      this.map.flyTo({
        center: coord,
        zoom: 18,
        essential: true
      });
    },

    resize: function () {
      if (this.map) {
        this.map.resize()
      }
    },

    clearMap() {
      if (this.map) {
        this.travelMethod = 'driving';
        this.activeVenue = null;
        this.route = null;
        this.clearMarkers();
        this.clearRoutes();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Amenity.js